<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    tokenRefresh() {
      let admininfo = window.localStorage.getItem("adminInfo");
      if (!admininfo) {
        return;
      }
      //token刷新
      this.$http.post(this.$api.tokenRefresh).then((res) => {
        if (res.success) {
          window.localStorage.setItem("_cyw_token", res.data.token);
          if (window.framework && window.framework.jsSetLoginUser) {
            admininfo = JSON.parse(admininfo);
            admininfo.Authorization = window.localStorage.getItem("_cyw_token");
            if (admininfo.hasOwnProperty("_CompGID")) {
              // 要和手持机的用户一一对应
              delete admininfo["_CompGID"];
            }
            window.framework.jsSetLoginUser(JSON.stringify(admininfo));
          }
        }
      });
    },
  },
  created() {
    window.setInterval(() => {
      setTimeout(this.tokenRefresh(), 0);
    }, 300000);
    let admininfo = window.localStorage.getItem("adminInfo");
    if (admininfo) {
      admininfo = JSON.parse(admininfo);
      if (window._exceptionlessClient) {
        window._exceptionlessClient.config.setUserIdentity(
          admininfo.UserCode,
          admininfo.UserName
        );
        window._exceptionlessClient.config.useSessions();
      }
      if (window.framework && window.framework.jsSetLoginUser) {
        admininfo.Authorization = window.localStorage.getItem("_cyw_token");
        if (admininfo.hasOwnProperty("_CompGID")) {
          // 要和手持机的用户一一对应
          delete admininfo["_CompGID"];
        }
        window.framework.jsSetLoginUser(JSON.stringify(admininfo));
      }
    }

    // store状态持久化
    if (window.localStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(window.localStorage.getItem("store"))
        )
      );
    }
    window.addEventListener("beforeunload", () => {
      window.localStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {},
  destroyed: {},
};
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.van-nav-bar__title,
.van-nav-bar__text,
.van-icon-arrow-left:before {
  color: #fff !important;
}
</style>
